// @ts-nocheck
import React from "react";
// @ts-ignore - lib/vd is a JS module without type definitions
import vd from "lib/vd";
import { completeEurekaAuthIfPossible } from "../../../utils/eureka";
import { ButtonV2 } from "../../../components/button-v2";
import { Text } from "../../../components/text";
import logo from "../../../assets/images/logo_color.png";

export const EurekaCallbackPage = () => {
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    // get the token from the url params and log in the user with it
    (async () => {
      try {
        const { code, codeVerifier, redirectUri } =
          await completeEurekaAuthIfPossible();

        return vd
          .authentication()
          .authenticate({
            eureka: {
              code,
              codeVerifier,
              redirectUri,
            },
          })
          .then(({ token, cubeJsToken, user, partner }: any) => {
            if (!token) {
              throw new Error("Invalid login");
            }
            localStorage.setItem("currentUserToken", token);
            localStorage.setItem("currentUserCubeJSToken", cubeJsToken);
            localStorage.setItem(
              "currentUser",
              JSON.stringify({
                ...user,
                businessName: partner?.businessName ?? "",
              }),
            );
            window.location.href = "/";
          })
          .catch((err) => {
            console.log("Error during authentication:", err);
            setError(err?.message ?? "An unexpected error occurred.");
          });
      } catch (err) {
        console.log("Error completing Eureka auth:", err);
        setError((err as Error)?.message ?? "An unexpected error occurred.");
      }
    })();
  }, []);

  if (error) {
    return (
      <div className="flex justify-center items-center h-full bg-gray-100 p-4">
        <div
          className="w-full flex flex-col items-center gap-4"
          style={{ maxWidth: 400 }}
        >
          <img src={logo} alt="Logo" style={{ height: 60, width: "auto" }} />
          <Text variant="bodySm" alignment="center">
            Sign in failed.
          </Text>
          <ButtonV2
            size="xl"
            fullWidth
            onClick={() => (window.location.href = "/login")}
          >
            Go back to login
          </ButtonV2>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-full bg-gray-100 p-4">
      <div
        className="w-full flex flex-col items-center gap-4"
        style={{ maxWidth: 400 }}
      >
        <img src={logo} alt="Logo" style={{ height: 60, width: "auto" }} />
        <Text variant="bodySm" alignment="center">
          Completing sign in, please wait...
        </Text>
      </div>
    </div>
  );
};
